import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hometwo-key-features',
  templateUrl: './hometwo-key-features.component.html',
  styleUrls: ['./hometwo-key-features.component.scss']
})
export class HometwoKeyFeaturesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
